import script from "./AbitRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbitRadio.vue?vue&type=script&lang=ts&setup=true"

import "./AbitRadio.vue?vue&type=style&index=0&id=06036dcc&lang=scss"

const __exports__ = script;

export default __exports__